module.exports = fox._r("images/settings.png", __webpack_public_path__ + "images/settings.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/settings.png
// module id = 1108
// module chunks = 4